import React from "react";

const DesktopStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 13.5C8 13.5 8.25 16.5 6.25 17.5H14.25C12.25 16.5 12.5 13.5 12.5 13.5M8 13.5H15.5C16.6046 13.5 17.5 12.6046 17.5 11.5V5C17.5 3.89543 16.6046 3 15.5 3H5C3.89543 3 3 3.89543 3 5V11.5C3 12.6046 3.89543 13.5 5 13.5H8Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(DesktopStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;